
export default function AboutSection() {
  return (
    <section id="about" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block bg-primary-100 text-primary-700 px-4 py-2 rounded-full text-sm font-tajawal font-medium mb-4">
            عن المنصة
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 font-cairo mb-6">
            بوابتك الموحدة للقبول الجامعي
          </h2>
          <p className="text-xl text-gray-600 font-tajawal max-w-3xl mx-auto leading-relaxed">
            نسعى لتسهيل رحلة الطالب في البحث عن الفرص التعليمية المناسبة من خلال منصة شاملة ومحدثة
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100">
            <div className="w-16 h-16 bg-primary-100 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-database-2-line text-3xl text-primary-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 font-cairo mb-4">قاعدة بيانات شاملة</h3>
            <p className="text-gray-600 font-tajawal leading-relaxed">
              نجمع معلومات القبول من جميع الجامعات السعودية الحكومية والأهلية في مكان واحد
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100">
            <div className="w-16 h-16 bg-saudi-gold-100 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-time-line text-3xl text-saudi-gold-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 font-cairo mb-4">تحديثات فورية</h3>
            <p className="text-gray-600 font-tajawal leading-relaxed">
              نتابع مواعيد القبول والتسجيل بشكل مستمر لضمان حصولك على أحدث المعلومات
            </p>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow border border-gray-100">
            <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mb-6">
              <i className="ri-customer-service-2-line text-3xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 font-cairo mb-4">دعم ذكي</h3>
            <p className="text-gray-600 font-tajawal leading-relaxed">
              مساعد ذكي متاح على مدار الساعة للإجابة على استفساراتك ومساعدتك في اختيار الجامعة المناسبة
            </p>
          </div>
        </div>

        {/* Mission & Vision */}
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-primary-600 to-primary-700 rounded-3xl p-10 text-white">
            <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-focus-3-line text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold font-cairo mb-4">رسالتنا</h3>
            <p className="text-white/90 font-tajawal leading-relaxed text-lg">
              تمكين الطلاب والطالبات من الوصول السهل والسريع لجميع معلومات القبول الجامعي في المملكة العربية السعودية، وتوفير تجربة بحث سلسة تساعدهم في اتخاذ قرارات تعليمية مدروسة.
            </p>
          </div>

          <div className="bg-gradient-to-br from-saudi-gold-500 to-saudi-gold-600 rounded-3xl p-10 text-white">
            <div className="w-14 h-14 bg-white/20 rounded-xl flex items-center justify-center mb-6">
              <i className="ri-eye-line text-3xl"></i>
            </div>
            <h3 className="text-2xl font-bold font-cairo mb-4">رؤيتنا</h3>
            <p className="text-white/90 font-tajawal leading-relaxed text-lg">
              أن نكون المرجع الأول والأشمل للقبول الجامعي في المملكة، ونساهم في تحقيق رؤية 2030 من خلال دعم مسيرة التعليم وتمكين الشباب السعودي من بناء مستقبلهم الأكاديمي.
            </p>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-20 bg-white rounded-3xl p-10 shadow-lg border border-gray-100">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-primary-600 font-cairo mb-2">50+</div>
              <div className="text-gray-600 font-tajawal">جامعة وكلية</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-primary-600 font-cairo mb-2">200+</div>
              <div className="text-gray-600 font-tajawal">تخصص أكاديمي</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-primary-600 font-cairo mb-2">13</div>
              <div className="text-gray-600 font-tajawal">منطقة مغطاة</div>
            </div>
            <div className="text-center">
              <div className="text-4xl md:text-5xl font-bold text-primary-600 font-cairo mb-2">24/7</div>
              <div className="text-gray-600 font-tajawal">دعم متواصل</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
